import { render, staticRenderFns } from "./ProductTileList.vue?vue&type=template&id=4f0486e7&scoped=true"
import script from "./ProductTileList.vue?vue&type=script&lang=js"
export * from "./ProductTileList.vue?vue&type=script&lang=js"
import style0 from "./ProductTileList.vue?vue&type=style&index=0&id=4f0486e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0486e7",
  null
  
)

export default component.exports